// extracted by mini-css-extract-plugin
export var buttonContainer = "ReactivateToday_buttonContainer__hOzw2";
export var couponSelectorContainer = "ReactivateToday_couponSelectorContainer__awaIl";
export var divider = "ReactivateToday_divider__p8x+s";